import {detectMobile} from '../../../js/utils';

export default class Header {
  constructor(searchSelector = '.js-swa-search-icon', cartSelector = '.js-swa-cart-icon') {
    this.searchSelector = searchSelector;
    this.cartSelector = cartSelector;
  }
  
  //TODO: Clean Up

  init() {
    const searchSelectorElement = document.querySelectorAll(this.searchSelector);
    const cartSelectorElement = document.querySelectorAll(this.cartSelector);
    const flyoutContainer = document.querySelector('.swa-header__flyout-container');

    if (!searchSelectorElement || !cartSelectorElement) {
      return;
    }
    
    searchSelectorElement.forEach((item, i) => {
      item.onclick = (event => {
        this.showSearchLayer(event);
        if (flyoutContainer.classList.contains('fade-outCart')) {
          flyoutContainer.classList.remove('fade-outCart');
        }
        if (flyoutContainer.classList.contains('fade-inCart')) {
          flyoutContainer.classList.remove('fade-inCart');
        }
        if (!flyoutContainer.classList.contains('swa-header__flyout-container--search')) {
          // If flyout container does not contain ".swa-header__flyout-container--search", the flyout needs to be closed
          // This case also applies when the user opens the search flyout and closes it by clicking again on the search icon
          flyoutContainer.classList.add('swa-hidden');

          // For transparent header - on mobile - hide the small logo when search flyout is closed
          if (detectMobile()) {
            this.hideHeaderLogoSmall();
          } else {
            const body = document.querySelector('body');
            body.style.overflowY = 'auto';
          }
        } else {
          if (flyoutContainer.classList.contains('swa-header__flyout-container--search')) {
            flyoutContainer.classList.remove('swa-hidden');
            // For transparent header - on mobile - show the small logo when search flyout is opened
            if (detectMobile()) {
              this.showHeaderLogoSmall();
            }
          }
        }
      });
    })
  }

  showHeaderLogoSmall() {
    const header = document.querySelector('.swa-header');
    const transparentHeader = document.querySelector('.js-swa-header-transparent');
    if (transparentHeader) {
      header.classList.add('swa-header--sticky');
      header.classList.add('swa-header--solid');
      header.classList.remove('swa-header--transparent');
    }
    const logoImage = document.querySelector(
      '.swa-header__compressed .swa-link__image--logo-mobile--default'
    );

    if (logoImage) {
      logoImage.src = logoImage.dataset.hover;
    }
  }

  hideHeaderLogoSmall() {
    const transparentHeader = document.querySelector('.js-swa-header-transparent');
    const header = document.querySelector('.swa-header');

    if (transparentHeader) {
      const mainNavigationHeight = 39;
      const stickyHeaderPositionTriggerSmall = 50 - mainNavigationHeight;
      let updatedScrollPosition = 0;

      updatedScrollPosition = window.pageYOffset;

      if (updatedScrollPosition < stickyHeaderPositionTriggerSmall) {
        header.classList.remove('swa-header--sticky');
        header.classList.remove('swa-header--solid');
        header.classList.add('swa-header--transparent');
        
        //If the small logo header transparent variation on mobile/tablet, use the white logo after the flyout container is closed
        const logoImageSmallMobile = document.querySelector('.swa-header__compressed-logo--show');
        const logoImage = document.querySelector('.swa-header__compressed .swa-link__image--logo-mobile--default');

        if (logoImageSmallMobile && !header.classList.contains('swa-header--transparent-light')) {
          logoImage.src = '/images/icons/swa-brandlogo-icon-big-white.svg';
        }
      }
    }
  }

  showSearchLayer(event) {
    const header = document.querySelector('.swa-header');
    const stickyHeader = document.querySelector('.swa-header--sticky');
    const flyoutContainer = header.querySelector('.swa-header__flyout-container');
    const searchFormInput = header.querySelector('.swa-input__search');
    const cartContainer = header.querySelector('.swa-header__cart-flyout');
    const cartIconUnderlined = header.querySelector('.swa-header__cart-icon');
    const cartIconUnderlinedSticky = header.querySelector('.swa-header__sticky-cart-icon');
    const searchIconUnderlined = header.querySelector('.swa-header__search-icon');
    const searchIconUnderlinedSticky = header.querySelector('.swa-header__sticky-search-icon');
    const transparentHeader = document.querySelector('.js-swa-header-transparent');
    const body = document.querySelector('body');
    const headerOverlay = header.querySelector('.swa-header__overlay');

    // focus directly on input programmatically does not work on Safari mobile, so a workaround is needed
    // we have to switch the focus to the target input from some other input that is already focused
    // in order to do that a new fake input (that won't be visible in page) is needed
    const pseudoInput = document.createElement('input');
    pseudoInput.style.position = 'absolute';
    pseudoInput.style.opacity = '0';
    pseudoInput.style.height = '0';
    // if not mobile (when the search flyout is full screen) => add the pseudo input to dom at the window location
    // to prevent the scroll because of the focused element
    if (!detectMobile() && stickyHeader) {
      pseudoInput.style.position = 'fixed';
      const y = window.scrollY;
      const x = window.scrollX;
      pseudoInput.style.left = x + "px";
      pseudoInput.style.top = y + "px";
    }
    document.body.prepend(pseudoInput);
    pseudoInput.focus({
      preventScroll: true
    });

    if (!detectMobile()) {
      if (header.classList.contains('swa-header--transparent-light') || header.classList.contains('swa-header--transparent-dark')) {
        header.classList.add('swa-header--transparent-solid-focus');
      }
    }

    if (cartIconUnderlined || cartIconUnderlinedSticky) {
      cartIconUnderlined.classList.remove('swa-active');
      cartIconUnderlinedSticky.classList.remove('swa-active');
    }

    if (!cartContainer.classList.contains('swa-hidden-cart')) {
      cartContainer.classList.add('swa-hidden-cart');
    }
    if (flyoutContainer.classList.contains('swa-hidden')) {
      body.style.overflowY = 'hidden';
    }

    searchFormInput.value = '';

    flyoutContainer.classList.toggle('swa-header__flyout-container--search'); // add min-height for the search layout parent container
    flyoutContainer.classList.remove('swa-hidden');
    searchIconUnderlined.classList.toggle('swa-active');
    searchIconUnderlinedSticky.classList.toggle('swa-active');
    if (headerOverlay) {
      if (searchIconUnderlined.classList.contains('swa-active')) {
        headerOverlay.classList.add('swa-active');
      } else {
        headerOverlay.classList.remove('swa-active');
      }
    }

    setTimeout(() => {
      searchFormInput.focus();
      // after focus on search input, the fake input created for Safari mobile can be removed
      pseudoInput.remove();
    }, 500);

    event.preventDefault();
  }
}
